import { useContext, useEffect, useReducer, useState } from "react";
import { Store } from "../Store";
import { getError } from "../utils";
import useAxios from "./useAxios";

const reducer = (state, action) => {
  switch (action.type) {
    case "FETCH_REQUEST":
      return { ...state, loading: true };
    case "FETCH_SUCCESS":
      return {
        ...state,
        loading: false,
      };
    case "FETCH_FAIL":
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default function useTableTypes() {
  const axios = useAxios();
  const { dispatch: ctxDispatch, state } = useContext(Store);
  const { tableTypes, userInfo } = state;
  const [{ loading, error }, dispatch] = useReducer(reducer, {
    loading: false,
    error: "",
  });

  const [loadTableTypes, setLoadTableTypes] = useState(false);

  const fetchTableTypes = async () => {
    try {
      dispatch({ type: "FETCH_REQUEST", payload: {} });
      const { data } = await axios.get(`/api/tabletypes`);

      dispatch({ type: "FETCH_SUCCESS", payload: data });
      ctxDispatch({
        type: "TABLE_TYPES_UPDATED",
        payload: data || [],
      });
    } catch (err) {
      dispatch({ type: "FETCH_FAIL", payload: getError(err) });
    }
  };

  useEffect(() => {
    if (userInfo && !tableTypes) {
      fetchTableTypes();
    }
  }, [userInfo]);

  useEffect(() => {
    if (loadTableTypes) {
      fetchTableTypes();
      setLoadTableTypes(false);
    }
  }, [loadTableTypes]);

  return [loading, error, setLoadTableTypes];
}
